import Vue from "vue";
import moment from "moment-timezone";

Vue.filter(
  "toJST",
  function (value, format = "MM DD YYYY HH:mm [(JST)]", isTBA = false) {
    return isTBA ? "TBA" : moment(value).tz("Asia/Tokyo").format(format);
  }
);
